import { Divider, Stack, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

// Icônes
import BusinessIcon from "@mui/icons-material/Business"; // SIREN/SIRET
import PhoneIcon from "@mui/icons-material/Phone";
import InfoIcon from "@mui/icons-material/Info"; // Type de client
import GavelIcon from "@mui/icons-material/Gavel"; // RM
import EuroIcon from "@mui/icons-material/Euro"; // Num TVA
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";

const InfoSupp = ({
  selectedClientData,
  selectedClientId,
  numTVA,
  phone,
  rm,
  siren,
  siret,
  typeClient,
  name,
  address,
  email,
  idUserClient,
}) => {
  const { t } = useTranslation();
  console.log(selectedClientData);
  console.log("selectedClientData", selectedClientData);
  console.log("idUserClient", idUserClient);
  const userClient = selectedClientData?.userClients?.find(
    (client) => client._id === idUserClient
  );
  console.log("selectedClientData", selectedClientData);
  return (
    <div
      className="invoice-field"
      style={{
        backgroundColor: "rgb(33 118 207)",
        padding: "1rem",
        borderRadius: "8px",
        color: "white",
      }}>
      {name ? (
        <Typography variant="h6" gutterBottom>
          {name}
        </Typography>
      ) : (
        <Typography gutterBottom sx={{ color: "gray" }}>
          {selectedClientId ? name : t("invoice.select_client_first")}
        </Typography>
      )}
      <Divider sx={{ my: 1 }} />
      {userClient?.name && (
        <Typography
          variant="body2"
          sx={{ display: "flex", alignItems: "center" }}>
          <strong>{t("invoice.name_destinataire")}:</strong>&nbsp;
          {userClient?.name}
        </Typography>
      )}
      {email && (
        <Typography
          variant="body2"
          sx={{ display: "flex", alignItems: "center" }}>
          <EmailIcon sx={{ fontSize: 16, mr: 1 }} />
          <strong>{t("invoice.email")}:</strong>&nbsp;{email}
        </Typography>
      )}{" "}
      {phone && (
        <Typography
          variant="body2"
          sx={{ display: "flex", alignItems: "center" }}>
          <PhoneIcon sx={{ fontSize: 16, mr: 1 }} />
          <strong>{t("invoice.phone")}:</strong>&nbsp;{phone}
        </Typography>
      )}
      {/* Adresse */}
      {address && (
        <Stack spacing={0.5} mb={1}>
          {address.split("\n").map((line, i) => (
            <Typography
              key={i}
              variant="body2"
              sx={{ display: "flex", alignItems: "center" }}>
              <LocationOnIcon sx={{ fontSize: 16, mr: 1 }} />
              {line}
            </Typography>
          ))}
        </Stack>
      )}
      {/* Informations supplémentaires */}
      <Stack spacing={1}>
        {siren && (
          <Typography
            variant="body2"
            sx={{ display: "flex", alignItems: "center" }}>
            <BusinessIcon sx={{ fontSize: 16, mr: 1 }} />
            <strong>{t("invoice.siren")}:</strong>&nbsp;{siren}
          </Typography>
        )}
        {siret && (
          <Typography
            variant="body2"
            sx={{ display: "flex", alignItems: "center" }}>
            <BusinessIcon sx={{ fontSize: 16, mr: 1 }} />
            <strong>{t("invoice.siret")}:</strong>&nbsp;{siret}
          </Typography>
        )}
        {typeClient && (
          <Typography
            variant="body2"
            sx={{ display: "flex", alignItems: "center" }}>
            <InfoIcon sx={{ fontSize: 16, mr: 1 }} />
            <strong>{t("invoice.client_type")}:</strong>&nbsp;{typeClient}
          </Typography>
        )}
        {numTVA && (
          <Typography
            variant="body2"
            sx={{ display: "flex", alignItems: "center" }}>
            <EuroIcon sx={{ fontSize: 16, mr: 1 }} />
            <strong>{t("invoice.vat_number")}:</strong>&nbsp;{numTVA}
          </Typography>
        )}

        {rm && (
          <Typography
            variant="body2"
            sx={{ display: "flex", alignItems: "center" }}>
            <GavelIcon sx={{ fontSize: 16, mr: 1 }} />
            <strong>{t("invoice.rm")}:</strong>&nbsp;{rm}
          </Typography>
        )}
      </Stack>
    </div>
  );
};

export default InfoSupp;
